import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '../ui/card';

const testimonials = [
  {
    id: 1,
    name: 'Sarah M.',
    location: 'Johannesburg',
    text: 'Absolutely amazing work! They transformed my old couch into something that looks brand new. Highly recommended!',
    rating: 5,
    service: 'Reupholstery'
  },
  {
    id: 2,
    name: 'David K.',
    location: 'Pretoria',
    text: 'Custom-built our L-shape couch exactly to our specifications. The quality is exceptional and the price was fair.',
    rating: 5,
    service: 'Manufacturing'
  },
  {
    id: 3,
    name: 'Linda P.',
    location: 'Cape Town',
    text: 'Fast delivery and excellent customer service. The couch exceeded our expectations. Will definitely buy again.',
    rating: 5,
    service: 'Sales'
  }
];

export const TestimonialsSection = () => {
  return (
    <section data-testid="testimonials-section" className="section-padding bg-secondary/30">
      <div className="container-custom">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="text-gold font-body text-sm uppercase tracking-widest">Testimonials</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-leather mt-2 mb-4">
            What Our Customers Say
          </h2>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Card 
                data-testid={`testimonial-${testimonial.id}`}
                className="h-full border-0 shadow-card hover:shadow-card-hover transition-all bg-white"
              >
                <CardContent className="p-8">
                  {/* Quote Icon */}
                  <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center mb-6">
                    <i className="fas fa-quote-left text-gold text-xl"></i>
                  </div>

                  {/* Stars */}
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="fas fa-star text-gold text-sm"></i>
                    ))}
                  </div>

                  {/* Text */}
                  <p className="text-leather/70 font-body leading-relaxed mb-6">
                    "{testimonial.text}"
                  </p>

                  {/* Author */}
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-leather flex items-center justify-center text-white font-heading font-bold">
                      {testimonial.name.charAt(0)}
                    </div>
                    <div>
                      <p className="font-heading font-semibold text-leather">
                        {testimonial.name}
                      </p>
                      <p className="text-sm text-leather/60 font-body">
                        {testimonial.location} • {testimonial.service}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
